module.exports = __webpack_public_path__ + "static/media/exclamation-square.83a2d7b2.svg";